import useRouter from "@stadium/hooks/lib/use-custom-route";
import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";

import { cumulativeCart } from "@actions/order";
import { clearOrder } from "@slices/order";
import { resetCart } from "@slices/cart";
import { useStoreContext } from "@components/store/provider";
import { getStoreHomeRoute } from "@constants/routes";

const useFetchOrder = () => {
  const dispatch = useDispatch();
  const router = useRouter();
  const [loading, setLoading] = useState(false);
  const [order, setOrder] = useState(null);

  const { storeBasePath } = useStoreContext();

  const postFetchOrder = useCallback(
    (order) => {
      setOrder(order);
      setLoading(false);

      //clear cart on successfull checkout
      dispatch(clearOrder());
      dispatch(resetCart());
    },
    [setLoading, setOrder],
  );

  const fetchOrder = useCallback(
    (orderId) => {
      setLoading(true);
      return dispatch(cumulativeCart(orderId))
        .then(postFetchOrder)
        .catch((err) => {
          setLoading(false);

          //unauthorized error
          if (err.response.status === 401) {
            router.push(getStoreHomeRoute({ storeBasePath }));
          } else {
            throw err;
          }
        });
    },
    [dispatch, postFetchOrder],
  );

  return {
    loading,
    order,
    fetchOrder,
  };
};

export default useFetchOrder;
